import { ReactElement, useCallback } from 'react'
import { Box, styled, useScrollTrigger, Zoom } from '@mui/material'
import { KeyboardArrowUp } from '@mui/icons-material'
import { zIndex } from '../../../../../src/theme/zIndex'
import { Translate2 } from 'common'
import { defaultTheme } from '../../../../../src/theme/index'
import { breakpoints } from '../../../../../src/theme/breakpoints'

const BackToTopButton = (): ReactElement => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  })

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <Zoom in={trigger}>
      <BackToTopBox role="presentation" onClick={scrollToTop}>
        <KeyboardArrowUp
          fontSize="medium"
          sx={{
            marginRight: '5px',
          }}
        />
        {Translate2('backToTop')}
      </BackToTopBox>
    </Zoom>
  )
}

export default BackToTopButton

const BackToTopBox = styled(Box)`
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: ${zIndex.tooltip};
  width: 157px;
  height: 48px;
  background-color: ${defaultTheme.colors.black};
  color: ${defaultTheme.colors.white};
  border-radius: 3px;
  font-family: 'Oswald', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;

  @media screen and (max-width: ${breakpoints.tablet}px) {
    bottom: 24px;
    right: 16px;
    width: auto;
    min-width: 48px;
    padding: 0 12px;
    font-size: 14px;
  }
`
